import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getBlogById } from '../api/blogs';

// Page détail d'un blog — données dynamiques depuis le backend
function SingleBlog() {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getBlogById(id)
            .then(data => {
                setBlog(data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [id]);

    if (loading) return <p className="text-center py-16 text-gray-400">Chargement...</p>;
    if (!blog) return <p className="text-center py-16 text-red-400">Blog non trouvé</p>;

    return (
        <article className="max-w-3xl mx-auto px-8 py-16">
            <Link to="/blogs" className="text-blue-400 hover:text-blue-300 text-sm mb-6 inline-block">← Retour aux blogs</Link>
            <h1 className="text-4xl font-bold mb-4">{blog.title}</h1>
            <div className="flex gap-4 text-sm text-gray-500 mb-8">
                {blog.user_name && <span>Par {blog.user_name}</span>}
                <span>•</span>
                <span>{new Date(blog.created_at).toLocaleDateString()}</span>
            </div>
            <div className="text-gray-300 leading-relaxed space-y-6">
                <p>{blog.content}</p>
            </div>
        </article>
    );
}

export default SingleBlog;